/**
 * The page's text keys — `presentation.texts.portalEditor` / `portalEditorFlows` of the backend's
 * `template-builder-email` schema, whose feature the menu entry rides on. The test checks every
 * key exists there in every language. `{site}` and `{tenant}` are filled with `fill`.
 */

export const FEATURE_KEY = 'template-builder-email';

/** The customer-portal flows the editor edits (`PortalFlow`), each under its own permission. */
export const EDITOR_FLOWS = [
  { flow: 'SERVICE_AGREEMENT', permission: 'template-service-agreements:read' },
  { flow: 'TYRE_ORDER', permission: 'template-tyres:read' },
  { flow: 'ACCEPT_OFFER', permission: 'template-service-agreements:read' },
] as const;

export const TEXT_GROUPS = {
  portalEditor: ['title', 'description', 'open', 'noSite', 'notConfigured', 'noOrgNode'],
  portalEditorFlows: EDITOR_FLOWS.map(({ flow }) => flow),
  builder: ['loading', 'loadFailed', 'retry'],
} as const;

export type PortalEditorTexts = {
  [Group in keyof typeof TEXT_GROUPS]: Record<(typeof TEXT_GROUPS)[Group][number], string>;
};
